module.exports = __webpack_public_path__ + "assets/img/Edito_Mouhammed-Choukeir_cover.8e08e9a0-ps.jpg";